import React, { useContext, useState, useRef, useEffect } from "react";
import { useAuth0 } from "../../react-auth0-spa";
import downloadImage from "../../Assets/images/download-slim.svg";
import accessSlim from "../../Assets/images/access-slim.svg";
import { postReportData } from "../../services/reportService";
import { ThemeContext } from "../../pages/FrontPage/FrontPage";
import moment from "moment";
import { useHistory, Link } from "react-router-dom";

interface ReportObj {
  report_name: string;
  report_group: string;
  publishing_date: string;
  file: string;
  file_path: string;
}

export const GetReportRowsForUser = (
  reports: any[],
  filter: string,
  setIsOpen: Function,
  setIsOpenKPIFailed: Function,
  setIsNordicPopupOpen: Function,
  isNordicPopupOpen: Boolean
) => {
  filter = filter.toLowerCase();
  const history = useHistory();
  const [notificationSent, setNotificationSent] = useState(null);
  const [activeNordicPopupKey, setActiveNordicPopupKey] = useState<
    number | null
  >(null);
  const nordicPopupRef = useRef<HTMLDivElement | null>(null);

  const theme = useContext(ThemeContext);
  const user = theme.user;
  const roles = theme.user["https://mediavision.se/roles"];
  const displayName = `${user["https://mediavision.se/app_metadata"].company} ${user.name}`;
  const {
    isAuthenticated,
    loginWithRedirect,
    logout,
    user: isTvStreamingUser,
  } = useAuth0();
  // let isAdmin = false;
  let isTvStreamRole = false;
  let isTvAnalyticsRole = false;
  let isContentRole = false;
  let isNordicTVRole = false;
  let isSportsRole = false;

  isTvStreamingUser["https://mediavision.se/roles"].map((a: any) => {
    if (a.name === "TV & Streaming Basic") {
      isTvStreamRole = true;
    }
  });
  isTvStreamingUser["https://mediavision.se/roles"].map((a: any) => {
    if (a.name === "TV & Streaming - Analytics") {
      isTvAnalyticsRole = true;
    }
  });
  isTvStreamingUser["https://mediavision.se/roles"].map((a: any) => {
    if (a.name === "Content Insights - Sweden Analytics") {
      isContentRole = true;
    }
  });
  isTvStreamingUser["https://mediavision.se/roles"].map((a: any) => {
    if (a.name === "Nordic TV & Streaming Basic") {
      isNordicTVRole = true;
    }
  });
  isTvStreamingUser["https://mediavision.se/roles"].map((a: any) => {
    if (a.name === "Nordic - Sport Analysis") {
      isSportsRole = true;
    }
  });

  useEffect(() => {
    function handleClickOutside(event: any) {
      if (
        nordicPopupRef.current &&
        !nordicPopupRef.current.contains(event.target)
      ) {
        setIsNordicPopupOpen(false);
        setActiveNordicPopupKey(null);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isNordicPopupOpen, activeNordicPopupKey, setIsNordicPopupOpen]);

  const rows = reports.map((item: ReportObj, key) => {
    const tempReportName = item.report_name.toLowerCase();
    const containsChar =
      tempReportName.includes(filter) || item.report_group.includes(filter);
    // let availableKPI = false;
    if (!containsChar) {
      return <tr></tr>;
    }

    // availableKPI = roles.find((role) => {
    //   return role.description.trim() === item.report_group.trim();
    // });

    const downloadReport = async () => {
      setIsOpen(true);
      const body = JSON.stringify({
        name: displayName,
        reportObjName: item.report_name,
        reportName: item.file_path,
        userId: user,
        report: item,
      });
      await postReportData(body).then((res) => {
        setNotificationSent(res.status);
      });
    };

    const navigateToKPI = () => {
      history.push("/metabase-dashboard");
    };
    const navigateToNordic = () => {
      history.push("/nordic");
    };
    const navigateToSports = () => {
      history.push("/sports-analysis");
    };
    const navigateToContent = () => {
      history.push("/content-dashboard");
    };

    const accessAnalytics = () => {
      history.push("/access-analytics");
    };

    const showError = () => {
      setIsOpenKPIFailed(true);
    };
    const hasTVStreamingAccess =
      item.report_name.includes("Insikt - TV & Streaming") ||
      item.report_name.includes("Insight - TV & Streaming");

    const hasSportsStreamingAccess =
      item.report_name.includes("Sports Analysis 2026");

    const hasContentAccess = item.report_name.includes("Content Analysis");
    const hasNordicAccess = item.report_name.includes("Nordic TV & Streaming");

    const isEnabled =
      (isTvStreamRole && hasTVStreamingAccess) ||
      (isNordicTVRole && hasNordicAccess) ||
      (isSportsRole && hasSportsStreamingAccess);

    const isAnalyticsEnabled =
      (isTvAnalyticsRole && hasTVStreamingAccess) ||
      (isContentRole && hasContentAccess);
    return (
      <tr key={key} style={{ position: "relative" }}>
        <td style={styles.tableBodyRowTD}>
          <div style={styles.left}>{item.report_name}</div>
        </td>
        <td style={{ ...styles.tableBodyRowTD }}>
          <div style={styles.left}>
            {moment(item.publishing_date).format("YYYY-MM-DD")}
          </div>
        </td>
        <td style={styles.tableBodyRowTD}>
          <a href="#" onClick={downloadReport}>
            <img src={downloadImage} alt="download" />
          </a>
        </td>
        <td style={styles.tableBodyRowTD}>
          <Link
            to="#"
            // onClick={
            //   isTvStreamRole && hasTVStreamingAccess ? navigateToKPI : showError
            // }
            onClick={() => {
              if (isTvStreamRole && hasTVStreamingAccess) {
                navigateToKPI();
              } else if (isNordicTVRole && hasNordicAccess) {
                // setIsNordicPopupOpen((prev) => !prev);
                // setActiveNordicPopupKey(key);
                navigateToNordic();
              } else if (isSportsRole && hasSportsStreamingAccess) {
                navigateToSports();
              }
              else {
                showError();
              }
            }}
            style={!isEnabled ? styles.disabled : {}}
          >
            <img src={accessSlim} alt="access-kpi" />
          </Link>
          {isNordicPopupOpen && activeNordicPopupKey === key && (
            <div ref={nordicPopupRef} style={styleDropdown.dropdown}>
              <div
                style={styleDropdown.dropdownItem}
                onClick={() => {
                  window.open("/nordic/denmark", "_blank");
                  setIsNordicPopupOpen(false);
                  setActiveNordicPopupKey(null);
                }}
              >
                Denmark
              </div>
              <div
                style={styleDropdown.dropdownItem}
                onClick={() => {
                  window.open("/nordic/finland", "_blank");
                  setIsNordicPopupOpen(false);
                  setActiveNordicPopupKey(null);
                }}
              >
                Finland
              </div>
              <div
                style={styleDropdown.dropdownItem}
                onClick={() => {
                  window.open("/nordic/sweden", "_blank");
                  setIsNordicPopupOpen(false);
                  setActiveNordicPopupKey(null);
                }}
              >
                Sweden
              </div>
              <div
                style={styleDropdown.dropdownItem}
                onClick={() => {
                  window.open("/nordic/norway", "_blank");
                  setIsNordicPopupOpen(false);
                  setActiveNordicPopupKey(null);
                }}
              >
                Norway
              </div>
            </div>
          )}
        </td>

        <td style={styles.tableBodyRowTD}>
          <Link
            to="#"
            onClick={() => {
              if (isTvAnalyticsRole && hasTVStreamingAccess) {
                accessAnalytics();
              } else if (isContentRole && hasContentAccess) {
                navigateToContent();
              } else {
                showError();
              }
            }}
            style={!isAnalyticsEnabled ? styles.disabled : {}}
          >
            <img src={accessSlim} alt="access-kpi" />
          </Link>

        </td>
      </tr>
    );
  });
  return rows;
};

const styles = {
  tableBodyRowTD: {
    height: "65px",
    fontSize: "16px",
    fontWeight: 300,
    alignItems: "right" as const,
    // posistion: relative,
  },
  disabled: {
    opacity: 0.3,
    // cursor: 'inherit',
  },
  left: {
    width: "95%",
    marginLeft: "auto" as const,
    textAlign: "left" as const,
  },
};

const styleDropdown = {
  dropdown: {
    position: "absolute" as const,
    background: "#fff",
    border: "1px solid #ddd",
    borderRadius: "6px",
    padding: "10px 0",
    width: "150px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    zIndex: 9999,
  },
  dropdownItem: {
    padding: "8px 15px",
    cursor: "pointer",
    fontSize: "14px",
  },
};
